document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-product-gallery").forEach(function (gallery) {
    const thumbnails = gallery.querySelectorAll(".custom-thumbnail");
    const slides = gallery.querySelectorAll(".custom-slide");
    const prevBtn = gallery.querySelector(".custom-prev-btn");
    const nextBtn = gallery.querySelector(".custom-next-btn");
    let index = 0;

    function stopAllVideos() {
      slides.forEach(s => s.querySelectorAll("video").forEach(v => { try{v.pause();}catch(e){} }));
    }

    function showSlide(i) {
      slides.forEach((s, idx) => s.classList.toggle("active", idx === i));
      thumbnails.forEach((t, idx) => t.classList.toggle("active", idx === i));
      stopAllVideos();
      slides[i].querySelectorAll("video").forEach(v => { try{v.play();}catch(e){} });
      index = i;
    }

    thumbnails.forEach((btn, i) => btn.addEventListener("click", () => showSlide(i)));
    if (prevBtn) prevBtn.addEventListener("click", () => showSlide((index - 1 + slides.length) % slides.length));
    if (nextBtn) nextBtn.addEventListener("click", () => showSlide((index + 1) % slides.length));

    showSlide(0);
  });
});
